<template>
  <div>
    <router-view></router-view>
    <component :is="isComponent"
               :value="currentValue"
               :desiredConditionInfo="desiredConditionValue"
               :orderInfo="orderValue"
               :googleForJobsArgs="googleForJobsValue"
               :birthYearInfo="birthSelect"
               :experienceYearInfo="experienceYearSelect"
               :prefectureInfo="prefectureSelect"
               :startTimeInfo="startTimeSelect"
               :workStyleInfo="workStyleSelect"
               :hospitalStyleInfo="hospitalStyleSelect"
               :jobKindInfo="jobKindSelect"
               :desiredExperienceYearInfo="desiredExperienceYearSelect"
               :salaryInfo="salarySelect"
               :imagePathInfo="imagePaths"
               :userStatusInfo="userStatus"
               :isInquired="isInquired"
               :isAfterUserRegistration="isAfterUserRegistration"
               :isResumeRegistered="isResumeRegistered"
               :phoneFormat="phoneFormat"></component>
  </div>
</template>

<script>
  import _ from 'lodash'
  import InquiryNew from './components/inquiries/InquiryNew'
  import InquiryThanks from './components/inquiries/InquiryThanks'
  import { mapGetters } from 'vuex'

  export default {
    name: 'inquiry',
    props: [
      'initialResult',
      'initialDesiredCondition',
      'initialOrderValue',
      'initialGoogleForJobsValue',
      'initialBirthSelect',
      'initialExperienceYearSelect',
      'initialStartTimeSelect',
      'initialWorkStyleSelect',
      'initialSalarySelect',
      'initialHospitalStyleSelect',
      'initialJobKindSelect',
      'initialPrefectureSelect',
      'initialDesiredExperienceYearSelect',
      'initialImagePaths',
      'initialUserStatus',
      'initialIsInquired',
      'initialIsAfterUserRegistration',
      'initialIsResumeRegistered',
      'initialPhoneFormat'
    ],

    data: function(){
      return {
        currentValue: _.cloneDeep(this.initialResult),
        desiredConditionValue: _.cloneDeep(this.initialDesiredCondition),
        orderValue: _.cloneDeep(this.initialOrderValue),
        googleForJobsValue: _.cloneDeep(this.initialGoogleForJobsValue),
        birthSelect: _.cloneDeep(this.initialBirthSelect),
        experienceYearSelect: _.cloneDeep(this.initialExperienceYearSelect),
        prefectureSelect: _.cloneDeep(this.initialPrefectureSelect),
        startTimeSelect: _.cloneDeep(this.initialStartTimeSelect),
        workStyleSelect: _.cloneDeep(this.initialWorkStyleSelect),
        salarySelect: _.cloneDeep(this.initialSalarySelect),
        hospitalStyleSelect: _.cloneDeep(this.initialHospitalStyleSelect),
        jobKindSelect: _.cloneDeep(this.initialJobKindSelect),
        desiredExperienceYearSelect: _.cloneDeep(this.initialDesiredExperienceYearSelect),
        imagePaths: _.cloneDeep(this.initialImagePaths),
        userStatus: _.cloneDeep(this.initialUserStatus),
        isInquired: _.cloneDeep(this.initialIsInquired),
        isAfterUserRegistration: _.cloneDeep(this.initialIsAfterUserRegistration),
        isResumeRegistered: _.cloneDeep(this.initialIsResumeRegistered),
        phoneFormat: _.cloneDeep(this.initialPhoneFormat)
      }
    },

    computed: mapGetters('inquiry', {
      'isComponent': 'getComponent',
      'getValue': 'getValue'
    }),

    created: function(){
      // 直接そのテンプレートを指定した場合の挙動
      if (this.$route.name == 'Thanks') {
        this.$store.commit('setThanksCount')
      }
    },

    mounted: function() {
      this.pushDataLayer()
    },

    methods: {
      pushDataLayer: function() {
        window.dataLayer.push({'event': 'optimize.activate'})
      }
    },

    components: {
      InquiryNew: InquiryNew,
      InquiryThanks: InquiryThanks
    }
  }
</script>
